// extracted by mini-css-extract-plugin
export var actionText = "_nz-4";
export var container = "_nz-0";
export var leftSection = "_nz-1";
export var rightSection = "_nz-2";
export var settingsButton = "_nz-6";
export var settingsIcon = "_nz-7";
export var shortcut = "_nz-5";
export var shortcutGroup = "_nz-3";